module.exports = __webpack_public_path__ + "img/btn-1.56fdf95b.png";